import { useI18n } from 'builder/hooks/useI18n'
import { TRANSLATION } from '../constants'
import * as Styles from './styles'

export const QuestionnaireInfo = () => {
  const { i18n } = useI18n()

  return (
    <Styles.InfoSection>
      <Styles.InfoSectionIcon>
        <svg width="12.255995" height="14.764" viewBox="0 0 12.255995 14.764">
          <defs id="defs12" />
          <path
            d="m 6.1279975,14.064 a 5.428,5.428 0 1 1 0,-10.856 5.428,5.428 0 0 1 0,10.856 z"
            stroke="currentColor"
            strokeWidth="1.4"
            fill="transparent"
            id="path2"
          />
          <path
            d="m 4.0379975,0.70000001 h 4.176"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
            id="path4"
          />
          <path
            d="m 8.8419975,8.635 a 2.715,2.715 0 0 0 -2.714,-2.714"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            id="path6"
          />
        </svg>
      </Styles.InfoSectionIcon>
      <Styles.InfoSectionDescription>
        {i18n.t(`${TRANSLATION}.time`)}
        <Styles.InfoSectionDescriptionBold>
          {i18n.t(`${TRANSLATION}.time_minutes`)}
        </Styles.InfoSectionDescriptionBold>
      </Styles.InfoSectionDescription>
    </Styles.InfoSection>
  )
}
